import React, { Fragment, useContext, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  Paper,
  Avatar,
  Typography,
  Divider,
  Button,
} from "@material-ui/core";
import DataUsageRoundedIcon from "@material-ui/icons/DataUsageRounded";
import WallpaperRoundedIcon from "@material-ui/icons/WallpaperRounded";

// Contexts
import OrderContext from "../../../../context/orders/v1/OrdersContext";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    fontSize: "0.9rem",
  },
  avatar: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    color: "white",
  },
  rowBottom: {
    marginBottom: "1rem",
  },
  // lineItemBox: {
  //   height: "4.5rem",
  // },
  title: {
    color: theme.palette.text.primary,
    fontWeight: "bold",
    marginTop: "0.3rem",
  },
  title2: {
    marginTop: "0.5rem",
  },
  image: {
    width: 50,
    border: "1px solid whitesmoke",
  },
  divider: {
    marginTop: "1rem",
    marginBottom: "1rem",
  },
  button: {
    textTransform: "none",
  },
  textLeft: {
    textAlign: "left",
  },
}));

const OrderEditItemUnfulfilled = ({ getImage, unfulfilledItems, products }) => {
  const classes = useStyles();
  const { setModal } = useContext(OrderContext);

  const [totalItems, setTotalItems] = useState(0);

  useEffect(() => {
    if (unfulfilledItems.length > 0) {
      let total_items = 0;

      unfulfilledItems.map((item) => {
        total_items += item.fulfillable_quantity;
      });

      setTotalItems(total_items);
    }
  });

  return (
    unfulfilledItems.length > 0 && (
      <Grid container direction="column" justifyContent="flex-start">
        <Paper className={classes.paper}>
          {" "}
          {/* Title */}{" "}
          <Grid
            item
            xs={12}
            container
            direction="row"
            alignItems="center"
            justifyContent="flex-start"
            className={classes.rowBottom}
          >
            <Grid item>
              <Avatar
                className={classes.avatar}
                style={{
                  backgroundColor: "orange",
                }}
              >
                <DataUsageRoundedIcon />
              </Avatar>{" "}
            </Grid>{" "}
            & ensp;{" "}
            <Grid item>
              <Typography variant="body1" className={classes.title}>
                Unfulfilled({totalItems}){" "}
              </Typography>{" "}
            </Grid>{" "}
          </Grid>
          {/* Items */}{" "}
          {unfulfilledItems.map((item, index) => {
            const image =
              products[item.product_id] &&
              getImage(item.variant_id, products[item.product_id]);

            return (
              <Fragment key={index}>
                <Grid
                  item
                  xs={12}
                  container
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  className={classes.lineItemBox}
                >
                  <Grid
                    item
                    xs={2}
                    container
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                  >
                    {" "}
                    {image ? (
                      <img className={classes.image} src={image} />
                    ) : (
                      <WallpaperRoundedIcon fontSize="large" />
                    )}{" "}
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    container
                    direction="column"
                    alignItems="flex-start"
                    justifyContent="center"
                    className={classes.textLeft}
                  >
                    <Grid item> {item.title} </Grid>{" "}
                    <Grid item> {item.variant_title} </Grid>{" "}
                    <Grid item> SKU: {item.sku} </Grid>{" "}
                  </Grid>
                  <Grid
                    item
                    xs={2}
                    container
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                  >
                    $ {item.price} & ensp; x & ensp; {item.fulfillable_quantity}{" "}
                  </Grid>
                  <Grid
                    item
                    xs={2}
                    container
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                  >
                    ${" "}
                    {(
                      parseFloat(item.price) *
                      parseFloat(item.fulfillable_quantity)
                    ).toFixed(2)}{" "}
                  </Grid>{" "}
                </Grid>

                <Divider className={classes.divider} orientation="horizontal" />
              </Fragment>
            );
          })}
          {/* Mark As Fulfilled Button */}{" "}
          <Grid
            item
            xs={12}
            container
            direction="row"
            alignItems="center"
            justifyContent="flex-end"
          >
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={() => setModal(true, "fulfillment")}
            >
              Mark as fulfilled{" "}
            </Button>{" "}
          </Grid>{" "}
        </Paper>{" "}
      </Grid>
    )
  );
};

export default OrderEditItemUnfulfilled;
